module.exports = __webpack_public_path__ + "img/canada-male.9cca02e5.png";